var render = function render(){var _vm=this,_c=_vm._self._c;return _c('description-wrap',{attrs:{"description":_vm.party.description,"lines":_vm.lines}})
}
var staticRenderFns = []

export { render, staticRenderFns }